import {
  GET_ALL_DRUG_DETAILS,
  GET_DRUG_DETAILS,
  GET_ALL_FORMULTION,
} from '../types'

const INITIAL_STATE = {
  getalldrugs: [],
  getdrugdetail: [],
  getPagination: {},
  allFormulation: [],
}

const whoReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_DRUG_DETAILS:
      return {
        ...state,
        getalldrugs: payload.data,
        getPagination: payload.total_records,
      }
    case GET_DRUG_DETAILS:
      return {
        ...state,
        getdrugdetail: payload.data,
      }
    case GET_ALL_FORMULTION:
      return {
        ...state,
        allFormulation: payload.data,
      }
    default:
      return state
  }
}

export default whoReducer
